module.exports = __webpack_public_path__ + "static/media/super_party_pack_french_128.bf7bfd8c.png";